import LoadingIndicator from '@orn/shared-web/components/LoadingIndicator';

const LoadingTableState = () => {
  return (
    <div className="flex h-56 items-center justify-center">
      <LoadingIndicator size="md" />
    </div>
  );
};

export default LoadingTableState;
